// extracted by mini-css-extract-plugin
export default {"msgM":"_9b48e19ab3"};